// This file was auto-generated by Fern from our API Definition.
/** The two kinds of thing an agent can be addressed by. */
export const ChannelEventKind = {
    Message: "message",
    Action: "action",
};
